import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import VuetableFieldSequence from "vuetable-2/src/components/VuetableFieldSequence.vue";
import numeral from 'numeral'
import i18n from '@/plugins/i18n';
import { convertTimezone } from "@/common/tenancy/convertTimezone";

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

export default [
    {
        // id: 'name',
        name: 'orderNo',
        title: i18n.t('Order No.'),
        filterable: false,
        togglable: true,
        // formatter: (data) => {
        //     var html = '';
        //     return data.first_name;
        // }
    },
    {
        id: 'receiver',
        name: 'receiver',
        title: i18n.t('Receiver'),
        filterable: true,
        togglable: true,
        // formatter: (data) => {
        //     return formatNumber(data.numberOfOrder);
        // }
    },

    {
        id: 'payment',
        name: 'payment',
        title: i18n.t('Payment'),
        filterable: true,
        togglable: true,
        // formatter: (data) => {
        //     return formatNumber(data.upsell);
        // }
    },
    {
        id: 'qty',
        name: 'qty',
        title: i18n.t('_Report.QTY'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'totalNormal',
        name: 'totalNormal',
        title: i18n.t('_Reports.Product Sales'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'totalSales',
        name: 'totalSales',
        title: i18n.t('Total Sales'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'salesStaff',
        name: 'salesStaff',
        title: i18n.t('Sales Staff'),
        filterable: true,
        togglable: true,
        // titleClass: "text-center",
        // dataClass: "text-center",
    },
    {
        id: 'createdDate',
        name: 'createdDate',
        title: i18n.t('Created Date'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return convertTimezone.utcToLocal(data);
        }
        // titleClass: "text-center",
        // dataClass: "text-center",
    }
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/product_sales_detail_normal_fields.js